import React from 'react';
import { useIntl } from 'react-intl';
import WfbAdsSectionComponent from '@fuww/library/src/Articles/Sections/WfbAds';
import breakpoints from '@fuww/library/src/Theme/breakpoints';
import { WfbAdsWithoutQuery } from '../../Company/WfbAds';
import { wfbAdsHomePageImageConfigurations, wfbAdsLogoImageConfigurations }
  from '../../../lib/imageConfigurations';
import {
  ProfileSorting,
  WFBProfilesQuery,
  WFBProfilesQueryVariables,
} from '../../../lib/graphql/api/graphql';
import wfbProfilesQuery
  from '../../../lib/queries/jobs/wfbProfilesQuery.graphql';
import messages from '../../../lib/messages.json';
import withQuery from '../../../lib/withQuery';
import { useSiteContext } from '../../SiteContext';

const WfbAdsSectionWithoutQuery = (
  { data, variables }: {
    data: WFBProfilesQuery;
    variables: WFBProfilesQueryVariables;
  },
) => {
  const intl = useIntl();

  return data.profiles.length === 4 ? (
    <WfbAdsSectionComponent
      wfbAdsHeader={
        intl.formatMessage(messages['company-profiles.title'])
      }
    >
      <WfbAdsWithoutQuery
        data={data}
        variables={variables}
        gridGap="24px"
        sizes={`
        (min-width: 1440px) 330px,
        (min-width: ${breakpoints.lg}px) calc(25vw - 40px),
        (min-width: ${breakpoints.md}px) calc(34vw - 27px),
        (min-width: ${breakpoints.xs}px) calc(50vw - 28px),
        calc(100vw - 32px)
      `}
      />
    </WfbAdsSectionComponent>
  ) : null;
};

const WfbAdsSectionWithQuery = withQuery<
WFBProfilesQuery,
WFBProfilesQueryVariables
>(WfbAdsSectionWithoutQuery);

const WfbAdsSection = () => {
  const { jobsLocale } = useSiteContext();

  return (
    <WfbAdsSectionWithQuery
      query={wfbProfilesQuery}
      variables={{
        limit: 4,
        locales: [jobsLocale],
        imageConfigurations: wfbAdsHomePageImageConfigurations,
        logoConfigurations: wfbAdsLogoImageConfigurations,
        sort: ProfileSorting.RANDOM,
      }}
      errorMessage=""
    />
  );
};

export default WfbAdsSection;
